import { createFileRoute } from '@tanstack/react-router'
import BusinessPlanSettings from '@/features/business-plan-settings'
import { ProtectedRoute } from '@/components/auth/protected-route'
import { Permissions } from '@/constants/roles-permissions'

export const Route = createFileRoute('/_authenticated/business-plan-settings')({
  component: BusinessPlanSettingsRoute,
})

function BusinessPlanSettingsRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.AccountingTransactionView}>
      <BusinessPlanSettings />
    </ProtectedRoute>
  )
}
